module.exports = __webpack_public_path__ + "img/9788961471527.7dd4075e.jpg";